export default __webpack_public_path__ + "static/media/mask13.78ff64b8.jpeg";